import { createProp } from '@thyme/nashville/src/utils/designTokens'
import { nashColors } from '@thyme/nashville/tailwind.config'

// ENUMS --------------------
export enum Padding {
  SM = 'sm',
  MD = '', // Default
  LG = 'lg',
}

export enum Size {
  XS = 'xs',
  SM = 'sm',
  MD = '', // Default
  LG = 'lg',
  XL = 'xl',
}

export enum Actions {
  Primary = '', // Default
  Secondary = 'secondary',
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Help = 'help',
  Danger = 'danger',
  Chip = 'chip',
}

// PROPS --------------------

// new colors
export const ColorPalettes = {
  ...Object.keys(nashColors).reduce((acc, key: string) => {
    ;(acc as { [key: string]: string })[`nash-${key}`] = `nash-${key}`
    return acc
  }, {}),
}

/**
 *
 * @param opts
 * @param opts.default
 * @param opts.required
 */
export function makePaddingProp(opts?: {
  default?: string
  required?: boolean
}) {
  return { padding: createProp(Padding, opts?.default, opts?.required) }
}
/**
 *
 * @param opts
 * @param opts.default
 * @param opts.required
 */
export function makeSizeProp(opts?: { default?: string; required?: boolean }) {
  return { size: createProp(Size, opts?.default, opts?.required) }
}
/**
 *
 * @param opts
 * @param opts.default
 * @param opts.required
 */
export function makeActionProp(opts?: {
  default?: string
  required?: boolean
}) {
  return { action: createProp(Actions, opts?.default, opts?.required) }
}

/**
 *
 * @param opts
 * @param opts.default
 * @param opts.required
 */
export function makeColorProp(opts?: { default?: string; required?: boolean }) {
  return { color: createProp(ColorPalettes, opts?.default, opts?.required) }
}
/**
 *
 * @param opts
 * @param opts.default
 * @param opts.required
 */
export function makeBackgroundProp(opts?: {
  default?: string
  required?: boolean
}) {
  return {
    backgroundColor: createProp(ColorPalettes, opts?.default, opts?.required),
  }
}
